import type { ReactElement } from "react"

import { useTranslation } from "react-i18next"

import { formatCellsData } from "../../../features/ModelConfigurations/Helpers"
import type { HeatMapData } from "./ConfusionMatrix"
import { ConfusionMatrix } from "./ConfusionMatrix"

export function ConfusionMatrixChart(props: Readonly<{ chartData: HeatMapData[] }>): ReactElement {
  const { t } = useTranslation("graphs")
  const { chartData } = props

  return (
    <ConfusionMatrix
      title={t("confusionMatrix.title")}
      data={chartData}
      graphHeight={120}
      isLoading={false}
      tooltipText={
        <>
          {t("confusionMatrix.tooltip.description")}
          <br />
          {t("confusionMatrix.tooltip.brokenDownByLabel")}
        </>
      }
      padding="1rem"
      margin={{ left: 95, top: 20 }}
      label={(cell) => formatCellsData(cell, t)}
    />
  )
}
